import { render, staticRenderFns } from "./QuestionIndex.vue?vue&type=template&id=6eeafbb3&scoped=true&"
import script from "./QuestionIndex.vue?vue&type=script&lang=ts&"
export * from "./QuestionIndex.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionIndex.vue?vue&type=style&index=0&id=6eeafbb3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eeafbb3",
  null
  
)

export default component.exports